import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const FeatureAllInvestmentsGraphic = () => (
  <StaticQuery
    query={graphql`
      query {
        single: file(relativePath: { eq: "graphics/feature-all-investments/single/graphic.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <Img fluid={data.single.childImageSharp.fluid} imgStyle={{objectFit: 'contain'}} alt="Maintain and track multi-asset investments"/>
      )
    }}
  />
)
export default FeatureAllInvestmentsGraphic
